export default __webpack_public_path__ + "static/media/pfd_icon1@2x.0dad7c6b.png";